import ExpenseItem from './ExpenseItem'
import React from 'react'
import { MdDelete } from 'react-icons/md'
const ExpenseList = ({ expenses, handleDelete, handleEdit, clearItems }) => {
  return (
    <>
      <ul className='list'>
        {expenses.map(expense => {
          return (
            <ExpenseItem
              key={expense.id}
              expense={expense}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
            />
          )
        })}
      </ul>
      {expenses.length > 0 && (
        <button className='btn' onClick={clearItems}>
          Clear expense
          <MdDelete className='btn-icon' />
        </button>
      )}
    </>
  )
}

export default ExpenseList
